// GERADO por scripts/geo/build-mun.ts — não editar (FB-04). Malha municipal por UF, com hash de conteúdo, pedida
// sob demanda quando a UF entra em foco. O site ao vivo e o do replay importam este módulo.
export const MUN_REGISTRY_ID = '3c379426ad2d3fbb';

export const MUN_MESH: Readonly<Record<string, string>> = {
  AC: '/geo/mun/AC.9659aef4b6.topo.json',
  AL: '/geo/mun/AL.52fe4f8342.topo.json',
  AM: '/geo/mun/AM.3304afc46e.topo.json',
  AP: '/geo/mun/AP.aa3c5e8b7e.topo.json',
  BA: '/geo/mun/BA.62e1fae77d.topo.json',
  CE: '/geo/mun/CE.060dca4f8d.topo.json',
  DF: '/geo/mun/DF.5d2500b5bd.topo.json',
  ES: '/geo/mun/ES.27f34c6cba.topo.json',
  GO: '/geo/mun/GO.0f65a57652.topo.json',
  MA: '/geo/mun/MA.e1f9b7f86f.topo.json',
  MG: '/geo/mun/MG.3d5bcb2ab3.topo.json',
  MS: '/geo/mun/MS.16408e35a7.topo.json',
  MT: '/geo/mun/MT.d949434b9f.topo.json',
  PA: '/geo/mun/PA.fc5907cba6.topo.json',
  PB: '/geo/mun/PB.267b719d16.topo.json',
  PE: '/geo/mun/PE.fe4347a9f4.topo.json',
  PI: '/geo/mun/PI.9d148929e0.topo.json',
  PR: '/geo/mun/PR.0835f7fe52.topo.json',
  RJ: '/geo/mun/RJ.cb31b39b53.topo.json',
  RN: '/geo/mun/RN.64f3721522.topo.json',
  RO: '/geo/mun/RO.f2d665124a.topo.json',
  RR: '/geo/mun/RR.ce0f148ded.topo.json',
  RS: '/geo/mun/RS.2441b9ecb2.topo.json',
  SC: '/geo/mun/SC.fda3d355cc.topo.json',
  SE: '/geo/mun/SE.7b4fc18978.topo.json',
  SP: '/geo/mun/SP.1bba07164d.topo.json',
  TO: '/geo/mun/TO.9e4e4fc0ef.topo.json',
};
